export default __webpack_public_path__ + "static/media/groupLilac.922ebf6c.png";